import debug from 'debug'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GEOLOC_MOVE_FROM_INITIAL } from '../../store/map/map.constants'
import { selectIsMapInitialized, selectMapTargetData } from '../../store/map/map.selectors'
import { acknowledgeMapMove } from '../../store/map/mapSlice'
import { useMapContext } from './MapContext'
import { bboxIsValid, MAP_FROM_APP_ACTION_MOVE } from './map.utils'
import { addDatadogRumError } from '../rum/DataDogRum'

const d = debug('map')

const useMapMoveHandler = () => {
  const { targetBbox, targetCenter, targetOptions = {} } = useSelector(selectMapTargetData)
  const { map, interact } = useMapContext()
  const dispatch = useDispatch()
  const mapInitialized = useSelector(selectIsMapInitialized)

  useEffect(() => {
    if (!map || (!targetBbox && !targetCenter)) return

    dispatch(acknowledgeMapMove())

    let move
    const options = {
      ...targetOptions,
      animate: !targetOptions.avoidAnimation,
      ...(targetOptions.withFastAnimation
        ? {
            easing: t => 1 - Math.pow(1 - t, 13)
          }
        : {})
    }

    const eventData = targetOptions.from === GEOLOC_MOVE_FROM_INITIAL ? {} : { fromAppAction: MAP_FROM_APP_ACTION_MOVE }

    if (d.enabled) {
      if (targetBbox) d('targetBbox', targetBbox, 'bboxIsValid', bboxIsValid(targetBbox))
      if (targetCenter) d('targetCenter', targetCenter)
    }

    if (targetBbox && bboxIsValid(targetBbox)) {
      move = () => {
        try {
          interact({ ...options, bounds: targetBbox }, eventData)
        } catch (e) {
          addDatadogRumError(e, { map: `targetBbox is ${JSON.stringify(targetBbox)}` })
        }
      }
    } else if (targetCenter) {
      move = () => {
        try {
          interact({ ...options, center: targetCenter }, eventData)
        } catch (e) {
          addDatadogRumError(e, { map: `targetCenter is ${JSON.stringify(targetCenter)}` })
        }
      }
    }
    mapInitialized ? setTimeout(move, 0) : map.once('load', move)
  }, [map, targetBbox, targetCenter, mapInitialized])
}

export default useMapMoveHandler
